export default __webpack_public_path__ + "static/media/SpinningArrows.a6a3a828.gif";